import config from 'SRC/config/config.yaml'

export const groups = config.adForm.equipmentGroups
